import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`DDDTW 社群志工、講師。熱衷鑽研架構以及企業應用項目如何導入軟體企業架構與領域設計方法，希望有朝一日能成為架構師。平時喜歡閱讀、健身慢跑，研究美股財報、偶爾透過寫作分享學習的收穫。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      